import React, { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Save, RefreshCw } from 'lucide-react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import ModuleLayout from '../../../layouts/ModuleLayout';
import LoyaltyProgramConfig from '../../../components/Admin/Promotions/Loyalty/LoyaltyProgramConfig';

/**
 * Loyalty Program Page
 *
 * Manage customer loyalty and rewards:
 * - Points system configuration
 * - Membership tiers
 * - Rewards catalog
 * - Referral program
 */
export default function LoyaltyProgramPage() {
  const [componentActions, setComponentActions] = useState(null);
  const [saving, setSaving] = useState(false);
  const location = useLocation();

  // Detect if accessed from CRM module
  const isCRMRoute = location.pathname.startsWith('/crm');
  const Layout = isCRMRoute ? ModuleLayout : AdminLayout;

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  const handleSave = async () => {
    if (componentActions?.onSave) {
      setSaving(true);
      await componentActions.onSave();
      setSaving(false);
    }
  };

  return (
    <Layout>
      <div className="flex flex-col h-full">
        {/* Sticky Header */}
        <div className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between sticky top-0 z-10">
          <div>
            <h1 className="text-lg font-bold text-slate-900">Loyalty Program</h1>
            <p className="text-xs text-slate-500">Configure rewards, tiers, and referral settings</p>
          </div>

          {/* Action Buttons — only shown when the child grants permission via renderActions */}
          <div className="flex items-center gap-2">
            {componentActions?.onSave && (
              <button
                onClick={handleSave}
                disabled={saving}
                className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-2 text-sm font-medium disabled:opacity-50"
              >
                {saving ? (
                  <>
                    <RefreshCw size={16} className="animate-spin" />
                    Saving...
                  </>
                ) : (
                  <>
                    <Save size={16} />
                    Save Changes
                  </>
                )}
              </button>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4 bg-slate-50">
          <LoyaltyProgramConfig renderActions={handleActionsReady} />
        </div>
      </div>
    </Layout>
  );
}